import styled from 'styled-components';

export const StyledContainer = styled.div`
  height: 100%;
  width: 100%;
`;
